import React from 'react';
import { SignIn } from "aws-amplify-react";
import PropTypes from "prop-types";
// Material Components
import Avatar from '@material-ui/core/Avatar';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import withStyles from '@material-ui/core/styles/withStyles';
//Custom Components
import LoaderButton from "../Buttons/LoaderButton"
// Auth Styles
import styles from "./AuthStyles"

class CustomSignIn extends SignIn {
  constructor(props) {
    super(props);
    this._validAuthStates = ["signIn", "signedOut", "signedUp"];
  }

  toForgotPassword = () => super.changeState("forgotPassword");

  handleSignIn = event => super.signIn(event);

  showComponent(theme) {
    const { classes } = this.props;
    return (
      <main className={classes.main}>
        <Paper className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Acesse sua Conta
          </Typography>
          <form className={classes.form} onSubmit={this.handleSignIn}>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="email">Email</InputLabel>
              <Input key="username" id="username" name="username" type="email" autoFocus onChange={this.handleInputChange}/>
            </FormControl>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="password">Senha</InputLabel>
              <Input key="password" id="password" name="password" type="password" onChange={this.handleInputChange}/>
            </FormControl>
            <Typography variant="caption" inline >Esqueceu sua senha? {' '}</Typography>
            <Link variant="caption" href="#" onClick={this.toForgotPassword}>Resetar Senha.</Link>
            <div className={classes.submit}>
              <LoaderButton
                type="submit"
                isLoading={this.state.loading}
                text="Entrar"
                loadingText="Entrando..."
                fullWidth
                circularProgressProps={{size:22, thickness:4.5, color:"primary", classes:{root: classes.spinner}}}
                variant="contained"
                color="primary"
              />
            </div>
          </form>
        </Paper>
      </main>
    )
  }
}

CustomSignIn.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CustomSignIn);
